import { useMutation } from '@tanstack/react-query';

import FileProcessingApiHandler from 'app/services/fileProcessingApiHandler';
import { useToast, buildError } from '@aslanpay/portal-common-lib';

export interface ConfirmEDFFileRequest {
  fileUploadId: string;
  // Only applies to EMPLOYEE_DATA_FILE uploads — fps ignores it for GIFTING_ONLY_EMPLOYEE_DATA_FILE.
  sendInvites?: boolean;
}

const useConfirmEDFFile = (options?: { onSuccess?: () => void; onError?: () => void }) => {
  const toast = useToast();

  return useMutation<void, Error, ConfirmEDFFileRequest>(
    ({ fileUploadId, sendInvites }) =>
      FileProcessingApiHandler.confirmFileUpload(fileUploadId, {
        'edf.invite-new-employees-automatically': !!sendInvites,
      }),
    {
      onSuccess: () => {
        toast({
          position: 'top-right',
          status: 'success',
          title: 'Success',
          description:
            'File has been accepted and is processing... please wait for the confirmation email.',
        });
        options?.onSuccess?.();
      },
      onError: (error) => {
        const errorMessage = buildError(
          error,
          'Sorry, it was not possible to import your employees. Please try again.'
        );

        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: errorMessage,
        });
        options?.onError?.();
      },
    }
  );
};

export default useConfirmEDFFile;
